import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE ,API_URLBLAZEOLD} = environment;

@Injectable({
  providedIn: 'root'
})

export class CommissionProfileService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    saveCommissionProfile(commissionProfileData: any) {
        const url = `${API_URLBLAZE}/transaction/commission-profile`;
        return this.http.post(url, commissionProfileData).pipe(catchError(this.handleError()));
    }

    updateCommissionProfile(commissionProfileData: any) {
      const url = `${API_URLBLAZE}/transaction/commission-profile`;
      return this.http.put(url, commissionProfileData).pipe(catchError(this.handleError()));
    }

    updateCommissionProfileSlab(commissionProfileSlabData: any) {
    const url = `${API_URLBLAZE}/transaction/commission-profile/slab`;
    return this.http.post(url, commissionProfileSlabData).pipe(catchError(this.handleError()));
  }

    productDropdown(countryId: any,subCategoryId:any) {
      const url = `${API_URLBLAZE}/product/sub-category?country=${countryId}&subCategory=${subCategoryId}`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    productDropdownForFilter() {
      const url = `${API_URLBLAZE}/product/page?page_size=ALL`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    serviceProviderDropdownForFilter() {
      const url = `${API_URLBLAZE}/transaction/service-provider?page_size=ALL`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    serviceProviderDropdown(countryId: any,productId:any) {
      const url = `${API_URLBLAZE}/transaction/service-provider?countryId=${countryId}&productIds=${productId}`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getCommissionProfile(commissionId: any) {
      const url = `${API_URLBLAZE}/transaction/commission-profile/${commissionId}`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getCommissionProfileSlab(commissionId: any) {
      const url = `${API_URLBLAZE}/transaction/commission-profile/${commissionId}/slabs`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    commissionProfileSlabStatus(status: any,remark:any) {
      const url = `${API_URLBLAZE}/transaction/commission-profile/slab/status/${status}`;
      return this.http.put(url,remark).pipe(catchError(this.handleError()));
    }

    //Get Commission audit trail
    getCommissionAuditTrail(commission:String,pageSize:number,pageNumber:number) {
      var url = "";
      var filter = "";
      if(commission != "" && commission != null){
        filter = filter+`&after%5B"commission_profile_id"%5D=${commission}`
      }
      url = `${API_URLBLAZEOLD}/audit-trail?entity=commission_profile_slab&page_size=${pageSize}&page_no=${pageNumber}&sort_dir=DESC&sort_column=eventTimestamp`+filter;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getCommissionProfileList(commissionProfileName : string,country:String,product:String,serviceProvider:String,page_size:number,page_no:number) {
      var url = "";
      var filter = "";
      if(commissionProfileName != ""){
        filter = filter+`&name=${commissionProfileName}`
      }
      if(country != "" && country != null){
        filter = filter+`&countryId=${country}`
      }
      if(product != "" && product != null){
        filter = filter+`&productId=${product}`
      }
      if(serviceProvider != "" && serviceProvider != null){
        filter = filter+`&serviceProviderId=${serviceProvider}`
      }
      url = `${API_URLBLAZE}/transaction/commission-profile?page_size=${page_size}&page_no=${page_no}`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}